module.exports = "../../../../platform/assets/pageMainIcon/industry_danjuweihulei1.svg";